import { put } from '../../../../infra/rest';

export const updateLeadCustomField = async (
  listCustomFieldId: string
): Promise<void> => {
  return put<void>(
    `/v1/custom-fields/lead-status`,
    {
      body: JSON.stringify({
        listCustomFieldId,
      }),
    },
    true
  );
};
